import React, {useEffect} from 'react';
import {Document, Page, PDFViewer, StyleSheet, Text, View} from '@react-pdf/renderer';
import {Colors} from "../../../assets/Colors";
import {useParams} from "react-router-dom";
import {useMutation} from "@tanstack/react-query";
import {fetchGet} from "../../../fetchers";

// Create styles
const styles = StyleSheet.create({
    page: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
    },
    title: {
        fontSize: 14,
        fontWeight: "bold"
    },
    title_sub: {
        paddingVertical: 15,
        fontSize: 12,
        textAlign: 'center',
        paddingRight: 35,
    },
    header_section: {
        flexDirection: 'row',
    },
    header_section2: {
        flexDirection: 'row',
        paddingTop: 10,
    },
    header_section3: {
        flexDirection: 'row',
        paddingTop: 30,
    },
    header_title: {
        width: 100,
        fontSize: 9,
        textAlign: 'justify',
    },
    header_Right: {
        width: 50,
        marginLeft: 150,
        fontSize: 9,
        textAlign: 'right',
    },
    header_mark: {
        width: 15,
        fontSize: 9,
        textAlign: 'justify',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    text: {
        fontSize: 9,
        textAlign: 'justify',
    },


    table: {
        display: 'flex',
        flexDirection: 'row',
        borderLeftWidth: 1,
        // borderRadius: 5,
        borderStyle: "solid",
    },
    tableRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    cell: {
        display: 'flex',
        paddingLeft: 3,
        paddingTop: 2,
        borderWidth: 1,
        borderBottom: 0,
        borderLeftWidth: 0,
        borderTopWidth: 1,
        borderStyle: "solid",
        fontSize: 10
    },
    cellSecondary: {
        display: 'flex',
        paddingLeft: 3,
        paddingTop: 2,
        borderWidth: 1,
        borderBottom: 0,
        borderTop: 0,
        borderLeftWidth: 0,
        borderStyle: "solid",
        fontSize: 10,
    },
    cellClosing: {
        display: 'flex',
        paddingLeft: 3,
        paddingTop: 2,
        borderWidth: 1,
        borderBottom: 1,
        borderLeftWidth: 0,
        borderTopWidth: 1,
        borderStyle: "solid",
        fontSize: 10
    },
    paddings: {
        paddingTop: 10,
    }
});

const combineStyles = (main, override) => {
    let result = {...main};
    let ov = {...override};
    if (typeof override === "object") {
        Object.assign(result, ov);
    }
    return result;
}
// Create Document Component
const BlankoPOReturn = (props) => {
    const data = props.data
    const Headermaker = (props) => (
        <View style={styles.header_section}>
            <Text style={styles.header_title}>
                {props.nama}
            </Text>
            <Text style={styles.header_mark}>
                :
            </Text>
            <Text style={styles.text}>
                {props.data}
            </Text>
        </View>
    )
    const HeaderTableMaker = (props) => {
        let style = {width: props.width + "%"};
        let style2 = {}
        if (props.closing)
            style2 = {borderBottom: 1};
        let style3 = {}
        if (props.number) {
            style3 = {textAlign: 'right', paddingRight: 22}
        }
        return (
            <Text style={combineStyles(combineStyles(combineStyles(styles.cell, style), style2), style3)}>
                {props.title}
            </Text>
        )
    }

    const splitStringByWidth = (inputString, maxWidth) => {
        const MAX_WIDTH = maxWidth;
        const words = inputString.split(' ');
        let currentLine = words[0];
        let result = '';

        for (let i = 1; i < words.length; i++) {
            const word = words[i];
            const tempLine = `${currentLine} ${word}`;

            if (tempLine.length > MAX_WIDTH) {
                result += currentLine + '\n';
                currentLine = word;
            } else {
                currentLine = tempLine;
            }
        }

        result += currentLine;
        return result;
    };

    const SecondaryTableMaker = (props) => {
        let style = {width: props.width + "%"};
        let style2 = {}
        if (props.closing) {
            style2 = {borderBottom: 1};
        }
        let style3 = {}
        if (props.number) {
            style3 = {textAlign: 'right', paddingRight: 22}
        }

        return (
            <Text style={combineStyles(combineStyles(combineStyles(styles.cellSecondary, style), style2), style3)}>
                {props.title}
            </Text>
        )
    }
    let Total = 0

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <Text style={styles.title}>
                    RANJI KARYA SAKTI{"\n"}
                </Text>
                <Text style={styles.title_sub}>
                    Bukti Penerimaan Barang {'\n'}
                    {data.GoodsAcceptanceID}
                </Text>
                <View style={styles.header_section}>
                    <Text style={styles.header_title}>
                        {"Nama Penerima"}
                    </Text>
                    <Text style={styles.header_mark}>
                        :
                    </Text>
                    <Text style={styles.text}>
                        {data.NamaPenerima}
                    </Text>

                    <Text style={styles.header_Right}>
                        {"Tanggal"}
                    </Text>
                    <Text style={styles.header_mark}>
                        :
                    </Text>
                    <Text style={styles.text}>
                        {new Date(data.Tanggal).toDateString()}
                    </Text>

                </View>
                <Headermaker nama={"PurchaseOrderID"} data={data.PurchaseOrderID}/>
                <Headermaker nama={"Keterangan"} data={data.Keterangan}/>

                {/*<ReactPdfTable.TableRow>*/}
                {/*    <ReactPdfTable.TableRow width={100} disableMargin={true}>*/}
                {/*        <ReactPdfTable.TableCell text="No" align="center" width={5}/>*/}
                {/*        <ReactPdfTable.TableCell text="2" align="left"/>*/}
                {/*        <ReactPdfTable.TableCell text="3" align="right"/>*/}
                {/*    </ReactPdfTable.TableRow>*/}

                {/*</ReactPdfTable.TableRow>*/}
                <View style={styles.paddings}></View>

                <View style={styles.table}>
                    <View style={[styles.tableRow]}>
                        <HeaderTableMaker width={5} title={"No"}/>
                        <HeaderTableMaker width={60} title={"Nama Barang"}/>
                        <HeaderTableMaker width={20} title={"Quantity"}/>
                        <HeaderTableMaker width={20} title={"Masuk"}/>

                    </View>
                </View>
                {data.Data.map((values, id) => {
                    let closing = false
                    if (id === data.Data.length - 1) {
                        closing = true
                    }
                    const newBody = splitStringByWidth(values.BarangID + " - " + values.NamaBarang, 50)

                    Total += (parseFloat(values.HargaSatuan) * parseFloat(values.Quantity))
                    return (
                        <View style={styles.table}>
                            <View style={[styles.tableRow]}>
                                <HeaderTableMaker closing={closing} width={5} title={id + 1}/>
                                <HeaderTableMaker closing={closing} width={60} title={newBody}/>
                                <HeaderTableMaker number={true} closing={closing} width={20} title={values.Qty}/>
                                <HeaderTableMaker number={true} closing={closing} width={20} title={values.QtyMasuk}/>

                            </View>
                        </View>
                    )
                })}
                <View style={styles.header_section2}>
                    <Text style={styles.header_title}>
                        {"Diinput Oleh"}
                    </Text>
                    <Text style={styles.header_title}>
                        DiPeriksa Oleh
                    </Text>
                    <Text style={styles.header_title}>
                        Disetujui Oleh
                    </Text>

                    <Text style={styles.header_title}>
                        {"Transportir"}
                    </Text>


                </View>
                <View style={styles.header_section3}>
                    <Text style={styles.header_title}>
                        {"................"}
                    </Text>
                    <Text style={styles.header_title}>
                        {"................"}
                    </Text>
                    <Text style={styles.header_title}>
                        {"................"}
                    </Text>

                    <Text style={styles.header_title}>
                        {"................"}
                    </Text>


                </View>
            </Page>

        </Document>
    )
}


const BlankoPenerimaan = () => {
    const params = useParams();
    const mutationGetBlanko = useMutation(formData => fetchGet("Procurement/GoodsAcceptance/one/" + formData))

    useEffect(() => {
        if (params.id) {
            mutationGetBlanko.mutate(params.id.replaceAll("-", '/'))
        }
    }, []);


    return (
        <div className="md:ml-64">
            <div
                style={{background: Colors.primary}}
                className="pt-14 pb-16 px-3 md:px-8 h-auto"
            >
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                </div>
            </div>
            <div className="px-3 md:px-8 h-screen -mt-32">
                {mutationGetBlanko.data &&
                    <PDFViewer className={"h-screen w-screen"}>
                        {<BlankoPOReturn data={mutationGetBlanko.data.data}/>}
                    </PDFViewer>
                }
            </div>
        </div>
    )
}
export default BlankoPenerimaan;
